import Vue from 'vue'
import store from '../store'

const isDui = (dui) => {
    if (dui === null) return false
    let valido = false;

    // Validando la longitud del numero de DUI
    if (dui.length === 10) {

        // Validando que no sea ceros todos los dígitos
        if (dui !== '00000000-0') {

            // Obteniendo los dígitos y el verificador
            let [digitos, validador] = dui.split('-');

            // Verficiando que la cadena
            if (typeof digitos !== 'undefined' && typeof validador !== 'undefined') {

                // Verificando que el validador sea de un solo caracter
                if (validador.length === 1) {

                    // Convirtiendo los digitos a array
                    digitos = digitos.split('');

                    // Convirtiendo los datos a tipo integer
                    validador = parseInt(validador, 10);
                    digitos = digitos.map(digito => parseInt(digito, 10));

                    // Obteniendo la suma corresponiente
                    let suma = digitos.reduce((total, digito, index) => total += (digito * (9 - index)), 0);

                    // Obteniendo el Modulo base 10
                    let mod = suma % 10;
                    mod = (validador === 0 && mod === 0) ? 10 : mod;

                    let resta = 10 - mod;

                    if (resta === validador) {
                        valido = true;
                    }
                }
            }
        }
    }
    return valido;
}


const maskDui = (value) => {
    value = value.replace(/[^\d\-]/, '')
    value = value.replace(/^([0-9]{8})([0-9])$/g, "$1-$2")
    value = value.replace(/^([0-9]{8}-)([0-9])([0-9]*)$/, "$1$2")
    return value
}
const restrictInteger = (value) => {
if (value.charCode >= 48 && value.charCode <= 57) {
        return true
    } else {
        value.preventDefault();
    }
}
const restrictDecimal = (value) => {
    if ((value.charCode >= 48 && value.charCode <= 57)|| value.charCode == 46) {
            if (value.target.value.indexOf('.') == -1) { return; }
            if ((value.target.value.length - value.target.value.indexOf('.')) > 1) {
            value.target.value = parseFloat(value.target.value).toFixed(1);
            }
            return true
        } else {
            value.preventDefault();
        }
}
const maskNit = (value) => {
    if (value === null) return null
    if(value.length===14 && value.indexOf('-')===-1){
        let digitos=value.split('')
        return digitos.reduce((nit, digito, index)=>{
            if(index===4 || index===10 || index===13){
                return nit+'-'+digito
            }else{
                return nit+digito
            }
        })
    }
    value = value.replace(/^([^\d\-])/, '')
    value = value.replace(/([0-9]{4}-)+([0-9]{6}-)+([0-9]{3}-)([0-9])([0-9]*)$/, '$1$2$3$4')
    value = value.replace(/^([0-9]{4}-)([0-9]{6}-)([0-9]{3})([0-9])$/, '$1$2$3-$4')
    value = value.replace(/^([0-9]{4}-)([0-9]{6})([0-9])$/, '$1$2-$3')
    value = value.replace(/^([0-9]{4})([0-9])$/, '$1-$2')
    value = value.length > 17 ? '' : value
    return value
}

const maskNumberPositive = (value) => {
    return value.replace(/[^\d.,]/, '')
}

const maskTel = (value) => {
    value = value.replace(/^([^\d\-])/, '')
    value = value.replace(/^([0-9]{4}-)([0-9]{4})([0-9]*)$/, '$1$2')
    value = value.replace(/^([0-9]{4})([0-9])$/, '$1-$2')
    return value
}

const isTelefono = (value) => {
    if (value === null) return false
    return /(\+\(\d*\) )?([762]\d{3}-)(\d{4})$/.test(value)
}

const validarFormulario = (form) => {
    let respuesta = true
    if (form.id.value && form.id.required) {
        return respuesta
    }
    Object.keys(form).forEach(element => {
        if (form[element].required) {
            if (form[element].type) {
                if (form[element].type === 'Array') {
                    if (validArrayEmpty(form[element].value)) {
                        form[element].state = true
                    } else {
                        form[element].state = false
                        respuesta = false
                    }
                } else if (form[element].type === 'String') {
                    if (validString(form[element].value))
                        form[element].state = true
                    else {
                        form[element].state = false
                        respuesta = false
                    }
                } else if (form[element].type === 'Number') {
                    if (validNumber(form[element].value)) {
                        form[element].state = true
                    } else {
                        form[element].state = false
                        respuesta = false
                    }
                }
            } else {
                if (validString(form[element].value))
                    form[element].state = true
                else {
                    form[element].state = false
                    respuesta = false
                }
            }
        }
    })
    return respuesta
}

const validArrayEmpty = (value) => {
    return value.length > 0
}

const validString = (value) => {
    return value !== null && value !== ''
}

const validNumber = (value) => {
    return !isNaN(value) && value !== null && value !== ''
}
const isEmail = (value) => {
    if (value === null) return false
    return /^(?!(?:(?:\x22?\x5C[\x00-\x7E]\x22?)|(?:\x22?[^\x5C\x22]\x22?)){255,})(?!(?:(?:\x22?\x5C[\x00-\x7E]\x22?)|(?:\x22?[^\x5C\x22]\x22?)){65,}@)(?:(?:[\x21\x23-\x27\x2A\x2B\x2D\x2F-\x39\x3D\x3F\x5E-\x7E]+)|(?:\x22(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|(?:\x5C[\x00-\x7F]))*\x22))(?:\.(?:(?:[\x21\x23-\x27\x2A\x2B\x2D\x2F-\x39\x3D\x3F\x5E-\x7E]+)|(?:\x22(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|(?:\x5C[\x00-\x7F]))*\x22)))*@(?:(?:(?!.*[^.]{64,})(?:(?:(?:xn--)?[a-z0-9]+(?:-[a-z0-9]+)*\.){1,126}){1,}(?:(?:[a-z][a-z0-9]*)|(?:(?:xn--)[a-z0-9]+))(?:-[a-z0-9]+)*)|(?:\[(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){7})|(?:(?!(?:.*[a-f0-9][:\]]){7,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?)))|(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){5}:)|(?:(?!(?:.*[a-f0-9]:){5,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3}:)?)))?(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))(?:\.(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))){3}))\]))$/.test(value)
}

const isNit = (nit) => {
    if (nit === null) return false

    let valido = false;

    // Validando la longitud del numero de DUI
    if( nit.length === 17 ) {
        // Validando que no sea ceros todos los dígitos
        if( nit !== '0000-000000-000-0' && nit.match(/^[0-9]{4}-[0-9]{6}-[0-9]{3}-[0-9]$/) ) {

            // Obteniendo los dígitos y el verificador por separado
            let [ ubicacion, fecha, correlativo, validador ] = nit.split('-');
            let digitos = ( ubicacion + fecha + correlativo ).split('');

            // Convirtiendo los datos a tipo integer
            validador   = parseInt(validador, 10);
            correlativo = parseInt(correlativo, 10);
            let suma = 0;
            let mod  = 0;
            if (correlativo <= 100) {
                // Obteniendo la suma corresponiente
                suma = digitos.reduce( (total, digito, index) =>  total += ( parseInt(digito, 10) * ( 14 - index ) ) , 0);
                // Obteniendo el Modulo base 11
                mod  = suma % 11;
                mod  = mod === 10 ? 0 : mod;
            } else {
                // Obteniendo la suma corresponiente
                suma = digitos.reduce( (total, digito, index) =>  total += ( parseInt(digito, 10) *  parseInt( ( 3 + 6 * Math.floor( ( index + 5 ) / 6 ) ) - ( index + 1 ), 10 ) ) , 0);
                // Obteniendo el Modulo base 11
                mod  = suma % 11;
                mod  = mod > 1 ? ( 11 - mod ) : 0;
            }
            if( mod === validador ) {
                valido = true;
            }
        }
    }
    return valido;
}

const numberFormat = (number) => {
    if (number === '' || number === null) return null
    number = String(number).replace(/,/g, '')
    return Number(number).toLocaleString('en', {style: "currency", currency: "USD", minimumFractionDigits: 2})
}

Vue.prototype.havePermiss = (permiso) => {
    return store.getters['getUserInfo'].roles.find(rol => rol === permiso)
}

const buscarMenu = async (menu, url) => {
    if(url==='/')return true
    return menu.find(item => {
        if (item.uri.includes('{id}')) {
            let base_url = item.uri.split('{id}')[0]
            let param = url.split(base_url)[1]
            let url_final = url.replace(param, '')
            return url_final === base_url
        }
        else if (item.uri.includes('{query}')) {
            let base_url = item.uri.split('{query}')[0]
            let param = url.split(base_url)[1]
            let url_final = url.replace(param, '')
            return url_final === base_url
        }
        else {
            return url === item.uri
        }
    })
}
const buscarUrl = async (url, from) => {
    if ( url.includes('/login') || url === '/forbidden' || url === '/carrusel' || url === '/recuperar' || url === '/prueba' || url === '/prueba_empresa') return true
    let menu = store.getters['utils/getMenu'];
    if(localStorage.urlRedirect){
        const response = await Vue.prototype.http_client('/api/v1/menu')
        response.data.sort((a, b) => (a.orden > b.orden) ? 1 : -1);
        await store.dispatch('utils/setMenu', response.data)
        return await buscarMenu(response.data, url)
    }
    if (menu.length > 0 && url!=='/') {
        return await buscarMenu(menu, url)
    }
    const response = await Vue.prototype.http_client('/api/v1/menu')
    response.data.sort((a, b) => (a.orden > b.orden) ? 1 : -1);
    await store.dispatch('utils/setMenu', response.data)
    return await buscarMenu(response.data, url)
}

export {
    isDui,
    validarFormulario,
    maskDui,
    maskNit,
    maskTel,
    isTelefono,
    isEmail,
    isNit,
    maskNumberPositive,
    numberFormat,
    buscarUrl,
    restrictDecimal,
    restrictInteger
}
